export default {
  brand: {
    name: 'CYMA',
    fullName: 'CYMA Petroleum Products (Zhenjiang) Co., Ltd.',
    tagline: 'Smart Chemistry · Custom Lubrication'
  },
  nav: {
    home: 'Home',
    about: 'About CYMA',
    products: 'Products',
    oil: 'Oil Products',
    water: 'Water-based',
    cases: 'Cases',
    contact: 'Contact',
    join: 'Careers'
  },
  hero: {
    badge: 'SIGMA PRECISION LUBRICATION',
    title: 'Custom Specialty Lubricants',
    titleAccent: 'Powering Industry Forward',
    subtitle: 'An integrated R&D, manufacturing, sales and service high-tech enterprise. Our mission: "Create Value Through Customization" — delivering smart chemical lubrication solutions worldwide.',
    ctaPrimary: 'Explore Products',
    ctaSecondary: 'Contact Us',
    stat1: 'Years Experience',
    stat1Unit: '+',
    stat2: 'Partner Companies',
    stat2Unit: '+',
    stat3: 'Custom SKUs',
    stat3Unit: '+',
    stat4: 'Certifications',
    stat4Unit: '+'
  },
  about: {
    label: 'ABOUT CYMA',
    title: 'About Us',
    subtitle: 'National Chemical Industrial · Metalworking · Specialty Lubrication',
    p1: 'Founded in 2010 in a national chemical industrial park, CYMA is a high-quality custom process lubricant manufacturer integrating production, R&D, sales and service.',
    p2: 'CYMA derives from the Greek letter Sigma (Σ), symbolizing leadership, wisdom and zero-defect quality. We pioneer "Smart Chemistry" with a "Customize + R&D + Service" model.',
    p3: 'We operate R&D, testing and analysis centers. Partnering with China University of Petroleum, Jiangsu University, Jiangsu University of Science and Technology and others, we offer strong technical supply capabilities with world-class blending, testing and analysis equipment. Products include custom specialty lubricants, wire drawing fluids, copper drawing fluids, cutting fluids, metalworking oils, rust preventives, heat transfer oils, high-temperature chain oils, refrigeration oils, compressor oils, vacuum pump oils, gear oils, hydraulic oils and more.',
    p4: 'CYMA is a nationally supported high-tech enterprise certified to ISO9001, ISO14001 and IATF16949, ensuring stable product quality and environmental protection. CYMA products have become a new trend in China\'s custom specialty lubricant industry. We are committed to full-service support, brand building and long-term strategic partnerships to advance China\'s specialty lubricant industry.'
  },
  pillars: {
    label: 'CORE CAPABILITIES',
    title: 'Three Core Strengths',
    tech: { title: 'Custom R&D', desc: 'Tailored lubrication solutions matched to your equipment and process conditions.' },
    product: { title: 'Product Delivery', desc: 'Advanced blending and strict QC ensure stable performance and on-time delivery.' },
    service: { title: 'Full Support', desc: 'On-site sampling, lab analysis and rapid response to your lubrication needs.' }
  },
  products: {
    label: 'PRODUCT LINES',
    title: 'Product Portfolio',
    oil: 'Oil-based Series',
    oilDesc: 'Industrial · Metalworking · Specialty',
    water: 'Water-based Series',
    waterDesc: 'Eco-friendly · Rust Prevention · Green Mfg',
    viewAll: 'View All'
  },
  culture: {
    label: 'CULTURE',
    title: 'Corporate Culture',
    items: [
      { title: 'Spirit', desc: 'Leadership through R&D and innovation' },
      { title: 'Vision', desc: 'Make custom lubricants our core competitiveness' },
      { title: 'Values', desc: 'Value created through products and services that benefit customers' },
      { title: 'Philosophy', desc: 'Customer-driven decisions and continuous process optimization' }
    ]
  },
  certs: {
    label: 'CERTIFICATIONS',
    title: 'Certifications',
    subtitle: 'International standards for quality and environment',
    items: ['ISO9001 Quality Management', 'ISO14001 Environmental Management', 'IATF16949 Automotive Quality', 'Hazardous Chemicals License']
  },
  cta: {
    title: 'Start Your Custom Lubrication Journey',
    subtitle: 'Expert team ready · Free technical consultation',
    button: 'Get in Touch'
  },
  footer: {
    rights: 'All Rights Reserved',
    icp: '苏ICP备19014159号',
    address: 'No.9 Songlinshan Rd, Dagang New District, Zhenjiang, Jiangsu',
    phone: '13913213555',
    email: 'runjia7@163.com'
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'Our expert team is ready to assist you',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    map: 'Our Location',
    viewMap: 'Click to view full image'
  },
  float: {
    phone: 'Phone',
    wechat: 'WeChat'
  },
  productsPage: {
    label: 'PRODUCTS',
    title: 'Product Center',
    subtitle: 'Oil-based and water-based lubricant lines, plus five specialty additive series',
    oilTitle: 'Oil-based Series',
    oilDesc: 'Industrial · Metalworking · Specialty',
    waterTitle: 'Water-based Series',
    waterDesc: 'Eco-friendly · Rust Prevention · Green Mfg',
    browse: 'Browse Series →',
    categories: 'Categories',
    subCategories: 'Products',
    empty: 'No products in this category',
    model: 'Model',
    intro: 'Introduction',
    features: 'Key Features',
    scope: 'Applications',
    specs: 'Typical Data',
    prev: 'Previous',
    next: 'Next',
    pageInfo: 'Page {page} of {total}',
    contactLabel: 'Tel: '
  },
  aboutPage: {
    label: 'ABOUT CYMA',
    title: 'About Us'
  },
  cases: {
    label: 'APPLICATIONS',
    title: 'Application Cases',
    subtitle: 'Lubrication solutions across wire drawing, 3C, automotive, battery and metalworking'
  },
  joinPage: {
    label: 'JOIN US',
    title: 'Join Us',
    subtitle: 'Grow with CYMA, shape the future of smart chemistry together',
    industryLabel: 'INDUSTRY',
    industryTitle: 'Target Industries',
    dutyLabel: 'RESPONSIBILITIES',
    dutyTitle: 'Job Responsibilities',
    reqLabel: 'REQUIREMENTS',
    reqTitle: 'Qualifications',
    locationLabel: 'LOCATIONS',
    locationTitle: 'Work Locations',
    contactTitle: 'Contact Us',
    hotline: 'Hotline',
    hotlineValue: 'Mr. Wang 18651818682',
    emailLabel: 'Resume Email',
    emailValue: 'wangwen@ximapetro.cn',
    jobs: [
      {
        name: 'Chemical Key Account Sales Manager',
        contactName: 'Mr. Wang',
        contactPhone: '18651818682',
        contactEmail: 'wangwen@ximapetro.cn',
        overview: [
          { label: 'Headcount', value: '6' },
          { label: 'Reports To', value: 'Product Line Sales Director' },
          { label: 'Subordinates', value: 'None' }
        ],
        industry: '',
        duties: [
          'Formulate annual, quarterly and monthly sales plans and target breakdowns based on company strategy and product market characteristics;',
          'Regularly analyze market dynamics, competitor movements and customer pain points, identify growth opportunities and propose new product R&D needs;',
          'Be responsible for core KPIs including sales revenue, gross margin and collection rate, ensuring achievement or overachievement of company sales targets;',
          'Handle customer information collection, bidding, quotation, negotiation and contract signing, process customer complaints, and regularly output sales reports with improvement recommendations;',
          'Perform other related duties as assigned.'
        ],
        requirements: [
          'College degree or above, 5+ years of B2B sales experience, familiar with the product line and industry customers;',
          'Proven annual sales record of 10M+ RMB with transferable customer resources;',
          'Familiar with the full key-account sales cycle, able to work independently and seek leadership support when needed.'
        ],
        locations: [
          { city: 'Zhenjiang', addr: 'No.9 Songlinshan Rd, International Chemical Park, Zhenjiang New District (CYMA Petroleum Sales (Zhenjiang) Co., Ltd.)' },
          { city: 'Kunshan', addr: 'Room 1102, 11F, Xianghe International Building, Kuntai Rd, Kunshan (CYMA Kunshan Office)' },
          { city: 'Shanghai', addr: 'Xinao Smart Valley, No.2350 Duzhuang Rd, Zhuanqiao, Minhang District (CYMA Group R&D and Sales Center)' }
        ]
      },
      {
        name: 'Silicone Oil Sales Director',
        contactName: 'Mr. Wang',
        contactPhone: '18651818682',
        contactEmail: 'wangwen@ximapetro.cn',
        overview: [
          { label: 'Headcount', value: '1' },
          { label: 'Reports To', value: 'Group Chairman' },
          { label: 'Subordinates', value: 'Key Account Sales Managers/Reps' },
          { label: 'Team Size', value: '3-6' }
        ],
        industry: '',
        duties: [
          'Formulate annual, quarterly and monthly sales plans for the silicone oil product line based on market strategy and characteristics (competition, customer needs, economic environment);',
          'Regularly analyze product line market dynamics, competitor movements and customer pain points, identify growth opportunities and propose new product R&D needs;',
          'Be responsible for product line KPIs including total sales revenue, gross margin and collections, ensuring the team meets or exceeds company targets;',
          'Guide key customer negotiations and contract signing, handle major customer complaints, regularly output product line sales reports with improvement recommendations;',
          'Build the product line sales team, responsible for team coaching and performance management;',
          'Perform other related duties as assigned.'
        ],
        requirements: [
          'College degree or above, under 45 (can be relaxed for outstanding candidates), 10+ years of B2B sales experience, 5+ years of sales team management experience;',
          'Familiar with silicone oil product line markets and industry customer resources, able to lead the team to achieve sales breakthroughs;',
          'Team building experience with outstanding sales track record (10M+ RMB level), strong breakthrough capability.'
        ],
        locations: [
          { city: 'Zhenjiang', addr: 'No.9 Songlinshan Rd, International Chemical Park, Zhenjiang New District (CYMA Petroleum Sales (Zhenjiang) Co., Ltd.)' },
          { city: 'Kunshan', addr: 'Room 1102, 11F, Xianghe International Building, Kuntai Rd, Kunshan (CYMA Kunshan Office)' },
          { city: 'Shanghai', addr: 'Xinao Smart Valley, No.2350 Duzhuang Rd, Zhuanqiao, Minhang District (CYMA Group R&D and Sales Center)' }
        ]
      },
      {
        name: 'Agrochemical Sales Director',
        contactName: 'Mr. Wang',
        contactPhone: '18651818682',
        contactEmail: 'wangwen@ximapetro.cn',
        overview: [
          { label: 'Headcount', value: '1' },
          { label: 'Reports To', value: 'Group Chairman' },
          { label: 'Subordinates', value: 'Key Account Sales Managers/Reps' },
          { label: 'Team Size', value: '5-20' }
        ],
        industry: '',
        duties: [
          'Formulate annual, quarterly and monthly sales plans for the agrochemical product line based on market strategy and characteristics (competition, customer needs, economic environment);',
          'Regularly analyze product line market dynamics, competitor movements and customer pain points, identify growth opportunities and propose new product R&D needs;',
          'Be responsible for product line KPIs including total sales revenue, gross margin and collections, ensuring the team meets or exceeds company targets;',
          'Guide key customer negotiations and contract signing, handle major customer complaints, regularly output product line sales reports with improvement recommendations;',
          'Build the product line sales team, responsible for team coaching and performance management;',
          'Perform other related duties as assigned.'
        ],
        requirements: [
          'College degree or above, under 45 (can be relaxed for outstanding candidates), 10+ years of B2B sales experience, 5+ years of sales team management experience;',
          'Familiar with agrochemical product line markets and industry customer resources, able to lead the team to achieve sales breakthroughs;',
          'Team building experience with outstanding sales track record (10M+ RMB level), strong breakthrough capability.'
        ],
        locations: [
          { city: 'Zhenjiang', addr: 'No.9 Songlinshan Rd, International Chemical Park, Zhenjiang New District (CYMA Petroleum Sales (Zhenjiang) Co., Ltd.)' },
          { city: 'Kunshan', addr: 'Room 1102, 11F, Xianghe International Building, Kuntai Rd, Kunshan (CYMA Kunshan Office)' },
          { city: 'Shanghai', addr: 'Xinao Smart Valley, No.2350 Duzhuang Rd, Zhuanqiao, Minhang District (CYMA Group R&D and Sales Center)' }
        ]
      },
      {
        name: 'Lubricant Sales Engineer',
        contactName: 'Ms. He',
        contactPhone: '15151669689',
        contactEmail: 'heyaqing@ximapetro.cn',
        overview: [],
        industry: '',
        duties: [
          'Responsible for sales and promotion of company oil products;',
          'Complete departmental sales targets according to marketing plans;',
          'Develop new markets, maintain existing customers, and expand product sales reach.'
        ],
        requirements: [
          'College degree or above, proficient in driving;',
          'Certain telemarketing and face-to-face sales capabilities;',
          'Experience in industrial product development preferred;',
          'B2B development sales experience preferred.'
        ],
        locations: [
          { city: 'Kunshan', addr: 'Xianghe International Building, Kuntai Road, Kunshan, Jiangsu' },
          { city: 'Ningbo', addr: 'No.518 Hengshan Rd, Beilun District, Ningbo' },
          { city: "Xi'an", addr: "Xi'an (Remote)" },
          { city: 'Wuxi', addr: 'No.8 Zhongyuan Rd, Huijian Hardware Market, Wuxi, Jiangsu' },
          { city: 'Shenzhen', addr: "No.2 Tongfuyu Industrial Park, Bao'an District, Shenzhen" }
        ]
      },
      {
        name: 'Lubricant Key Account Manager',
        contactName: 'Ms. He',
        contactPhone: '15151669689',
        contactEmail: 'heyaqing@ximapetro.cn',
        overview: [],
        duties: [
          'New customer development and maintenance: find customers, visit regularly, build and maintain customer relationships;',
          'Achieve sales targets: provide quality service, help customers solve problems, facilitate sales and meet targets;',
          'Collection capability: ensure timely collection of receivables, identify and resolve issues in the collection process.'
        ],
        requirements: [
          'Ability to open new markets from 0 to 1, 3+ years of B2B key account sales experience, successful track record of developing and maintaining customers with million-level annual purchases;',
          'Outstanding communication, coordination and negotiation skills, keen market insight and data analysis ability;',
          'Deeply engaged in industrial manufacturing, connecting with key decision-makers of leading customers across multiple sectors, with rapid business entry and project advancement capabilities.'
        ],
        locations: [
          { city: 'Kunshan', addr: 'Xianghe International Building, Kuntai Road, Kunshan, Jiangsu' },
          { city: 'Ningbo', addr: 'No.518 Hengshan Rd, Beilun District, Ningbo' },
          { city: "Xi'an", addr: "Xi'an (Remote)" },
          { city: 'Wuxi', addr: 'No.8 Zhongyuan Rd, Huijian Hardware Market, Wuxi, Jiangsu' },
          { city: 'Shenzhen', addr: "No.2 Tongfuyu Industrial Park, Bao'an District, Shenzhen" }
        ]
      },
      {
        name: 'Sales Manager',
        contactName: 'Ms. He',
        contactPhone: '15151669689',
        contactEmail: 'heyaqing@ximapetro.cn',
        overview: [],
        industry: '',
        duties: [
          'Strategic planning and target management: achieve company sales targets and new customer development;',
          'Key customer development: personally develop and maintain key customers in auto parts, home appliances, powder metallurgy, 3C electronics, industrial equipment, etc.;',
          'Customer relationship deepening: regularly visit key customers, understand their process needs, build stable strategic partnerships, enhance customer loyalty;',
          'Team training and coaching: build and maintain sales team, onboard and train new hires.'
        ],
        requirements: [
          'Proficient in driving, college degree or above (can be relaxed for outstanding candidates);',
          '5+ years of industrial manufacturing sales experience (cutting fluids / machinery / metal tubing / industrial consumables, etc.), 2+ years of team management experience;',
          'Successful track record of building and leading teams of 5+ members, with own industry customer resources preferred.'
        ],
        locations: [
          { city: 'Kunshan', addr: 'Xianghe International Building, Kuntai Road, Kunshan, Jiangsu' },
          { city: 'Ningbo', addr: 'No.518 Hengshan Rd, Beilun District, Ningbo' },
          { city: 'Wuxi', addr: 'No.8 Zhongyuan Rd, Huijian Hardware Market, Wuxi, Jiangsu' },
          { city: 'Shenzhen', addr: "No.2 Tongfuyu Industrial Park, Bao'an District, Shenzhen" }
        ]
      }
    ]
  }
}
